import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { ROLE_PERMS } from "../auth/rolePermissions";

const token = localStorage.getItem("jwtToken");

function normalizeUser(decoded) {
  const roleName = decoded?.role_name;

  // 1) pokud backend později začne dávat permissions do JWT: použij je
  // 2) jinak fallback podle role
  const permissions = Array.isArray(decoded?.permissions)
    ? decoded.permissions
    : (ROLE_PERMS[roleName] ?? []);

  return {
    ...decoded,
    role_name: roleName,
    permissions,
  };
}

let initialUser = null;

if (token) {
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp * 1000 > Date.now()) {
      initialUser = normalizeUser(decoded);
    } else {
      localStorage.removeItem("jwtToken");
    }
  } catch {
    localStorage.removeItem("jwtToken");
  }
}

const initialState = { user: initialUser };

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload ? normalizeUser(action.payload) : null;
    },
    logoutUser: (state) => {
      state.user = null;
    },
  },
});

export const { setUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;